import {
	StyledContainer,
	StyledDot,
	StyledDotsRow,
} from './PinCodeDots.styled';

interface IPinCodeDotsProps {
	length: number;
	active: number;
	error?: boolean;
}

const PinCodeDots: React.FC<IPinCodeDotsProps> = ({
	length,
	active,
	error,
}) => {
	const isFilled = active >= length && length > 0;

	return (
		<StyledContainer $filled={isFilled} $error={error}>
			<StyledDotsRow $length={length}>
				{Array.from({ length }).map((_, index) => (
					<StyledDot key={index} $active={index < active} $error={error} />
				))}
			</StyledDotsRow>
		</StyledContainer>
	);
};

export { PinCodeDots };
